import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './TimeInput.less'
import { NumberSpinner, Button } from 'common/components/inputs'
import moment from 'moment'
import Clock from 'styles/icons/schedule.svg'
import Svg from 'tickets/components/common/Svg'

import {
  hoursMsg,
  minutesMsg,
  updateMsg,
} from './TimeInput.messages'

class TimeInput extends Component {
  constructor(props) {
    super(props)
    const minute = Math.ceil(props.startMinute / props.minuteStep) * props.minuteStep
    this.state = {
      currentTime: new moment(`${props.startHour}:${minute}`, 'HH:mm'),
      show: false,
    }
    this.hour = props.startHour
    this.minute = props.startMinute

    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentWillMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside, false)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside, false)
  }

  onChange = () => {
    this.setState({
      show: false,
      currentTime: new moment(`${this.hour}:${this.minute}`, 'HH:mm'),
    })

    this.props.onChange({
      hour: this.hour,
      minute: this.minute,
    })
  }

  onClick = () => {
    this.setState((prevState) => ({
      show: !prevState.show,
    }))
  }

  onTimeInputChange = (evt) => {
    const currentTime = new moment(evt.target.value, 'HH:mm')
    const hour = parseInt(currentTime.format('HH'), 10)
    const minute = currentTime.format('mm')
    this.setState({
      currentTime,
    })
    this.props.onChange({
      hour,
      minute,
    })
  }

  onChangeHours = (hour) => {
    this.hour = hour
  }

  onInputFocus = () => {
    this.setState({
      inputFocused: true,
    })
  }

  onInputBlur = () => {
    this.setState({
      inputFocused: false,
    })
  }

  onChangeMinutes = (minute) => {
    this.minute = minute
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside = () => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        show: false,
      })
    }
  }

  render = () => {
    const { currentTime, show, inputFocused } = this.state
    const { minuteStep } = this.props
    const hour = parseInt(currentTime.format('HH'), 10)
    const minute = currentTime.format('mm')
    return (
      <div className={style.main} ref={this.setWrapperRef} data-test="timeInput">
        {!inputFocused &&
          <div className={style.cover} onClick={this.onClick} data-test="timeInputButton">
            <Svg className={style.clock} svg={Clock} />
            <span className={style.formattedTime}>
              {currentTime.format('HH:mm')}
            </span>
          </div>
        }
        {show &&
          <div className={style.timeSpinner}>
            <div className={style.timeSpinnerInner}>
              <NumberSpinner
                title={hoursMsg}
                startNumber={hour}
                maxNumber={24}
                onChange={this.onChangeHours}
                isTime
              />
              <NumberSpinner
                title={minutesMsg}
                startNumber={(minute / minuteStep)}
                maxNumber={60}
                stepSize={minuteStep}
                onChange={this.onChangeMinutes}
                isTime
              />
            </div>
            <div className={style.buttonWrapper}>
              <Button
                data-test="timeInputUpdate"
                fullWidth
                label={updateMsg}
                onClick={this.onChange}
              />
            </div>
          </div>
        }
        <input
          ref={(input) => { this.timeInput = input }}
          className={style.input}
          onFocus={this.onInputFocus}
          onBlur={this.onInputBlur}
          type="time"
          onChange={evt => this.onTimeInputChange(evt)}
          defaultValue={currentTime.format('HH:mm')}
        />
      </div>
    )
  }
}

TimeInput.defaultProps = {
  startHour: 8,
  startMinute: 0,
  minuteStep: 10,
}

TimeInput.propTypes = {
  startHour: PropTypes.number,
  startMinute: PropTypes.number,
  minuteStep: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export default TimeInput
